import router from './admin-panel.router'

export default {
  router,
}
